import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component = 'VerifyEmailContainer' | 'VerifyEmailResult';

/**
 * Errors related to the Verify Email page
 */
export const Errors = createErrors<Page, Component>('VerifyEmail')({
    VerifyEmailContainer: {
        VerifyCode: {
            severity: 'MEDIUM',
            message: 'Failed to verify email code.',
        },
        ResendEmail: {
            severity: 'MEDIUM',
            message: 'Failed to resend email verification code.',
        },
    },
    VerifyEmailResult: {
        ResendEmail: {
            severity: 'MEDIUM',
            message: 'Failed to resend Auth0 email verification.',
        },
    },
});
